import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { nextTick } from 'process';
import { TextAreaComponent } from '../../../shared/components/text-area/text-area.component';
/**
 * 文字區塊輸入元件
 */
@Component({
  selector: 'sigv-input-textarea',
  templateUrl: './input-textarea.component.html',
  styleUrls: ['./input-textarea.component.scss'],
})
export class InputTextareaComponent
  extends TextAreaComponent
  implements OnInit
{
  /** 如有設定則會顯示於 formValidate時的錯誤訊息 */
  @Input() fieldName?: string;
  /** 欲綁定formControl欄位名稱
   * @description useForm.controls['externalName']
   */
  @Input() bindingFormControl?: AbstractControl | any;
  /** 頁面是否純檢視*/
  @Input() isReadOnly: boolean = false;
  /** 純檢視時是否換行 (預設false)*/
  @Input() isBreakLineWhenReadonly: boolean = false;
  @Input() class: string = '';

  /** 空值欲設提示 */
  @Input() placeholder?: string;
  @Output() onResize = new EventEmitter<void>();
  constructor(injector: Injector, cd: ChangeDetectorRef) {
    super(injector, cd);
  }
  render = true;
  forceRender() {
    this.render = false;
    nextTick(() => {
      this.render = true;
    });
  }
  ngOnInit() {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isReadOnly'] || !changes['isReadOnly']) {
      this.forceRender();
    }
  }

  onChangeEvent(event: any) {
    this.textareaLength =
      event?.length ?? this.bindingFormControl.getRawValue()?.length ?? 0;
  }

  onResizeEvent(event: any) {
    this.onResize.emit(event?.currentTarget?.rows);
  }
}
